import { render } from "./AddPaiementModal.vue?vue&type=template&id=db45eaf4&scoped=true&ts=true"
import script from "./AddPaiementModal.vue?vue&type=script&lang=ts"
export * from "./AddPaiementModal.vue?vue&type=script&lang=ts"

import "./AddPaiementModal.vue?vue&type=style&index=0&id=db45eaf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db45eaf4"]])

export default __exports__